//2024年未使用

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import('./indexAppl');
const edit = () => import('./edit.vue');

export default {
  routes: [
    {
      path: '/smes/innovation/v2024/indexAppl',
      name: 'smes_innovation_v2024_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/smes/innovation/v2024/indexAdmin',
      name: 'smes_innovation_v2024_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/smes/innovation/v2024/edit',
      name: 'smes_innovation_v2024_edit',
      component: edit,
      meta: {public: true}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/innovation/v2024/router.js